import React, { ChangeEvent, memo, useEffect, useState } from 'react'
import { Form } from 'react-bootstrap'
import { checkUnsavedChanges } from '../../../../../../store/actions/configurationActions'
import { useAppDispatch } from '../../../../../../hooks/useAppDispatch'
import styles from './RuleNameInput.module.scss'
import { RULE_NAME } from '../../../utils/consts'
import { configsActions } from '../../../../../../store/slices/configsSlice'
import { PATH_JOINER } from '../../../../utils/getConfigBitPath'
import { setRuleCardRuleName } from '../../../../../../store/actions/ruleCardActions'
import { ruleCardActions } from '../../../../../../store/slices/ruleCardSlice'

export interface RuleNameInputProps {
    ruleName: string
    dataPath: string
    pathWithElementID: string
    isRequired: boolean
    isRuleActive: boolean | undefined
    className?: string
    isRuleCard?: boolean
}

export const RuleNameInput = memo(function RuleNameInput(props: RuleNameInputProps) {
    const dispatch = useAppDispatch()
    const {
        ruleName,
        isRequired,
        dataPath,
        pathWithElementID,
        isRuleActive,
        className,
        isRuleCard,
    } = props
    const [ruleNameModified, setRuleNameModified] = useState(ruleName)

    const isInvalid = isRequired && (!ruleNameModified || !ruleName)

    const path = [...(dataPath.split(PATH_JOINER)), RULE_NAME]
    const [guid, , tabName] = path
    const errorKey: string = pathWithElementID
        ? [...(pathWithElementID.split(PATH_JOINER)), RULE_NAME].join(PATH_JOINER)
        : path.join(PATH_JOINER)

    const handleEdit = (e: ChangeEvent<HTMLInputElement>) =>
        setRuleNameModified(e.target.value)

    const handleSave = () => {
        const payload = {
            path: dataPath.split(PATH_JOINER),
            ruleName: ruleNameModified,
        }
        if (isRuleCard) {
            dispatch(setRuleCardRuleName(payload))
        } else {
            dispatch(configsActions.setNewRuleName(payload))
            dispatch(checkUnsavedChanges(path[0]))
        }
    }

    const handleEnter = (evt: any) => {
        if (evt.key === 'Enter') {
            handleSave()
        }
    }

    const handleBlur = () => handleSave()

    useEffect(() => {
        if (isRuleCard) {
            dispatch(
                isInvalid
                    ? ruleCardActions.setRuleConfigInvalid({ errorKeyName: errorKey })
                    : ruleCardActions.setRuleConfigValid({ errorKeyName: errorKey })
            )
        } else {
            dispatch(
                isInvalid
                    ? configsActions.setConfigInvalid({ guid, tabName, errorKeyName: errorKey })
                    : configsActions.setConfigValid({ guid, tabName, errorKeyName: errorKey })
            )
        }
    }, [isInvalid, dispatch, errorKey, guid, tabName, isRuleCard])

    return (
        <span
            className={`d-flex align-center w-90 pe-5 p-relative ${className}`}
        >
            <Form.Control
                className={`${styles.ruleNameInput} ${
                    !isRuleActive && styles.ruleNameInactive
                } ${isInvalid && 'input-error'}`}
                type="text"
                placeholder={`Name ${isInvalid ? 'is required' : ''}`}
                value={ruleNameModified}
                onChange={handleEdit}
                onKeyUp={handleEnter}
                onBlur={handleBlur}
            />
        </span>
    )
})